import React from 'react';

const PlusButton = () => (
  <svg
    width="78px"
    height="78px"
    viewBox="0 0 78 78"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Plus Button</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g
      id="Desktop"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Cart-First-Time-User"
        transform="translate(-513.000000, -421.000000)"
        stroke="#52CAB8"
      >
        <g id="Group-14" transform="translate(390.000000, 376.000000)">
          <g id="Plus-Button" transform="translate(125.000000, 47.000000)">
            <circle id="Oval" strokeWidth="2.75" cx="37" cy="37" r="37" />
            <g
              id="Group-6"
              transform="translate(22.000000, 20.000000)"
              strokeWidth="3"
              strokeLinecap="square"
            >
              <path d="M15.5,0.566666667 L15.5,33.4333333" id="Line" />
              <path d="M31,16.5 L0,16.5" id="Line" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PlusButton;



// WEBPACK FOOTER //
// ./src/assets/PlusButton.jsx